export default class EventInfo {
    constructor($el) {
        this.$el = $el;
        this.$content = this.$el.querySelector('[data-event-info-content]');

        setTimeout(() => {
            const height = this.$content.scrollHeight;

            if (height < 80) {
                this.$el.classList.add('animate');
                return;
            }

            this.toggle = this.toggle.bind(this);

            this.collapsed = true;
            this.$toggle = this.$el.querySelector('[data-event-info-toggle]');
            this.toggleShowMoreLabel = this.$toggle.innerHTML;
            this.toggleShowLessLabel = this.$toggle.dataset.eventInfoToggle;
            this.$toggle.addEventListener('click', this.toggle);

            this.$content.style.setProperty('--event-info-content-height', `${this.$content.scrollHeight}px`);

            this.$content.classList.add('collapsed');
            this.$toggle.classList.remove('hidden');
            this.$el.classList.add('animate');
        }, 50);
    }

    toggle() {
        if (this.collapsed) {
            this.$content.classList.remove('collapsed');
            this.$toggle.innerHTML = this.toggleShowLessLabel;
        } else {
            this.$content.classList.add('collapsed');
            this.$toggle.innerHTML = this.toggleShowMoreLabel;
        }

        this.collapsed = ! this.collapsed;
    }
}